<template>
	<Card :dis-hover="true">
		<Tabs v-model="pageType" :animated="false" :capture-focus="true">
			<TabPane label="总监" name="inspector">
				<DeptMemberInspectorList v-if="pageType === 'inspector'" />
			</TabPane>
			<TabPane label="客户经理项目人" name="cusMgrLeader">
				<DeptMemberCusMgrLeaderList v-if="pageType === 'cusMgrLeader'" />
			</TabPane>
		</Tabs>
	</Card>
</template>

<script>
import DeptMemberInspectorList from './../../system-management/project-management/dept-member-inspector-list';
import DeptMemberCusMgrLeaderList from './../../system-management/project-management/dept-member-cusMgrLeader-list';

export default {
    name: 'DeptMemberListPage',
    components: {
        DeptMemberInspectorList,
        DeptMemberCusMgrLeaderList
    },
    data() {
        return {
            pageType: "inspector"
        };
    },
    mounted() {},
    methods: {}
};
</script>

<style scoped>
</style>
